var React = require("react");
var ReactDOM = require("react-dom");
var images = require("./images.js");

var AllPets = React.createClass({
    getBars: function(percent, type) {
        var color = "success";
        if(percent >= 0 && percent <= 30) {
            color = "danger";
        } else if(percent > 30 && percent <= 60) {
            color = "warning";
        }
        return (
            <div className="progress">                            
                <div className={"progress-bar progress-bar-striped progress-bar-"+color+" active"} style={{width: percent+'%'}}>
                    {percent+'% '+type}
                </div>
            </div>        
        );
    },
    render: function() {
        var that = this;
        return (
            <div className="row">
                {
                    Object.keys(this.props.pets).map(function(peti, idx){  
                        var pet = that.props.pets[peti];
                        if(!pet.name) {
                            pet.name = peti;
                        }                         
                        return (
                            <div className={that.props.isCurrent ? "col-md-push-3 col-md-6" : "col-md-4"} key={idx}>
                                <div className="col-sm-3 text-center">
                                    <img className="img-responsive" src={images.getImage(peti)} style={{display: 'inline'}} />
                                </div>
                                <div className="col-sm-9">
                                    <b style={{display: 'inline'}} dangerouslySetInnerHTML={{__html: pet.name.split("_").join(" ")+ " <span style='color:#3CE6E6'>[Level "+pet.level+"]</span>"}} title={peti} data-toggle="tooltip"></b>
                                    
                                    {that.getBars((pet.thirst ? pet.thirst : 0), "Thirst")}
                                    {that.getBars((pet.hunger ? pet.hunger : 0), "Hunger")}
                                    {that.getBars((pet.exercise ? pet.exercise : 0), "Exercise")}
                                    
                                </div>
                            </div>                               
                        );
                    })
                }
            </div>
        );
    }
});

var PlayerImage = React.createClass({
    render: function() {
        var currentPet = null;
        if(this.props.data.current) {
            currentPet = {};
            if(this.props.data.current in this.props.data.pets) {
                currentPet[this.props.data.current] = this.props.data.pets[this.props.data.current];
                delete this.props.data.pets[this.props.data.current];                
            }            
        }
        return (
            <div className="jumbotron text-center">
                <img src={"https://crafatar.com/renders/body/"+this.props.data.uuid+"?overlay&scale=4"} />
                <h2 dangerouslySetInnerHTML={{__html: this.props.data.name_readable}}></h2>
                {currentPet ? <AllPets pets={currentPet} isCurrent={true} /> : false}
                <AllPets pets={this.props.data.pets} isCurrent={false} />                    
            </div>
        );
    }
});

var LoadingBar = React.createClass({
    render: function() {
        return (
            <div className="jumbotron text-center">
                <div className="col-lg-12 row loadingBar"><h1><i className="fa fa-refresh fa-spin" /> Loading...</h1></div>
            </div>
        );
    }
});

var Pets = React.createClass({    
    getInitialState: function() {
        return {
            main: true,
            username: null,
            lastData: {}
        };     
    },
    componentDidUpdate: function() {
        $('[data-toggle="tooltip"]').tooltip();  
    },
    componentDidMount: function() {
        if(window.location.hash) { // little thing to handle hashes
            var name = window.location.hash.substring(1);
            this.setState({main: false, username: name}, function(){this.getPets();});
        }                  
    },
    getPets: function() {
        var that = this;
        window.location.hash = this.state.username;

        $.getJSON("https://pypixel.thedestruc7i0n.ca/pets/player/getPets.php?name="+this.state.username, function(data){
            if(data.error) {
                alert(that.state.username+" has no pets!");
                that.setState({main: true, username: null, lastData: {}}, function(){that.forceUpdate();});                
            } else {
                that.setState({lastData: data});                
            }            
        });
    },    
    run: function(e) {         
        this.setState({main: false, username: document.getElementById("username").value}, function(){
            this.getPets();
        });        
        e.preventDefault();           
    },
    render: function() {
        if(!this.state.main && !$.isEmptyObject(this.state.lastData)) {
            return <PlayerImage data={this.state.lastData} />
        }
        if(!this.state.main && $.isEmptyObject(this.state.lastData)) {            
            return <LoadingBar />
        };
        return (
            <div>
                <div className="jumbotron text-center">
                    <h1>Hypixel Pets Statistics</h1>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <form className="row" action method="GET" onSubmit={this.run} id="checkForm">
                                    <div className="form-group">
                                        <input type="text" ref="" autoComplete="off" autoCorrect="off" autoCapitalize="off" required className="form-control input-lg col-xs-x" id="username" name="name" placeholder="Username" maxLength={16} autoFocus />
                                    </div>
                                    <div className="form-group">
                                        <input type="submit" defaultValue="Go" className="btn btn-default" />
                                    </div>								
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

ReactDOM.render(<Pets />, document.getElementById("mount"));


/** WEBPACK FOOTER **
 ** ./src/main.jsx
 **/